<template>

<div 
	class="column" 
	:data-align="config.align || 'center'"
	:sortIndex="(sortingCount > 1 || sort !== 'name' || isSortedReverse) ? isSorted : 0" 
	v-tooltip="tooltip" 
	v-on:click="onClick" 
	:class="{
		'is-sortable': sort, 
		'is-sorted': isSorted
	}" 
>

	<template v-if="field.label">{{ field.label }}</template>
	<template v-if="config.icon && !field.label"><i class="fa-sharp" :class="{['fa-' + config.icon]: true}" /></template>

	<div class="column-index" v-if="isSorted && sortingCount > 1">{{ isSorted }}</div>

	<i v-if="filter" class="column-sort fa" v-bind:class="{'fa-caret-down': isSortedReverse, 'fa-caret-up': (!isSortedReverse) || (isSortedReverse)}" v-show="isSorted"></i>

</div>

</template>

<script>

import $field from '@/field'

export default {

	props: ['field', 'filter'],

	computed: {

		config: function() {

			return $field.type[this.field.type].config

		},

		sort: function() {

			return $field.type[this.field.type].sort

		},

		sortingCount: function() {
		
			return this.$util.sortcount((this.filter) ? this.$store.getters['filter/' + this.filter] : false)

		},

		tooltip: function() {
		
			return (this.sort) ? 'Click to sort<small>Shift-click to stack sort</small>' : false

		},

		isSorted: function() {

			return this.$util.sorted(this.sort, (this.filter) ? this.$store.getters['filter/' + this.filter] : false) 

		},

		isSortedReverse: function() {

			return this.$util.sorted(this.sort, (this.filter) ? this.$store.getters['filter/' + this.filter] : false, true) 

		}

	},

	methods: {

		onClick: function(e) {

			if (this.filter) this.$store.commit('filter/' + this.filter + '/sort', {
				value: this.sort,
				stack: e.shiftKey
			})

		}

	}

}

</script>

<style scoped>

.column {
	font-size: 12px;
	height: 32px;
	line-height: 12px;
	color: #333;
	font-weight: 500;
	display: flex;
	align-items: center;
	user-select: none;
}

.column.is-sortable {
	cursor: pointer;
}

.is-desktop .column.is-sortable.is-sorted[sortIndex="0"]:hover,
.is-desktop .column.is-sortable:not(.is-sorted):hover {
	background-color: #eee;
}

.column-sort {
	position: absolute;
	right: 4px;
	top: 50%;
	font-size: 16px;
	margin-top: -6px;
}

.column-sort.fa-caret-down {
	margin-top: -8px;
}

.column-index {
	color: #fff;
	background-color: rgba(0, 0, 0, 0.25);
	border-radius: 0px;
	left: -6px;
	border-radius: 4px;
	top: -6px;
	position: absolute;
	font-size: 12px;
	font-weight: 500;
	width: 16px;
	height: 16px;
	text-align: center;
	line-height: 16px;
	z-index: -2px;
}

.column[data-align="left"] {
	justify-content: flex-start;
}

.column[data-align="center"] {
	justify-content: center;
}

.column:not([sortIndex="0"]) {
	color: #fff;
}

.column[sortIndex="1"] {
	background-color: #61c7ff;
}

.column[sortIndex="1"] .column-index {
	background-color: #3a7fa6;
}

.column[sortIndex="2"] {
	background-color: #8be356;
}

.column[sortIndex="2"] .column-index {
	background-color: #5fa336;
}

.column[sortIndex="3"] {
	background-color: #ed5353;
}

.column[sortIndex="3"] .column-index {
	background-color: #b53333;
}

.column[sortIndex="4"] {
	background-color: #ed53df;
}

.column[sortIndex="4"] .column-index {
	background-color: #c135b4;
}

.column[sortIndex="5"] {
	background-color: #ff9d3b;
}

.column[sortIndex="5"] .column-index {
	background-color: #dc7e20;
}


</style>